import { useEffect, useState } from "react";
import { getAuthPersistenceStatus } from "../services/authPersistence";
import {
  detectPrivateBrowsingSignals,
  getLimitedSessionReason,
  probeBrowserSessionCapabilities,
} from "../utils/sessionCapabilities";

function buildCapabilities(privateSignals = {}) {
  const authStatus = getAuthPersistenceStatus();
  const probed = probeBrowserSessionCapabilities({
    authPersistenceMode: authStatus.mode,
    authPersistenceError: authStatus.error,
    ...privateSignals,
  });
  return {
    ...probed,
    limitedSessionReason: getLimitedSessionReason(probed),
  };
}

export function useSessionCapabilities() {
  const [capabilities, setCapabilities] = useState(() => buildCapabilities());

  useEffect(() => {
    let cancelled = false;
    let privateSignals = {};
    const refresh = () => {
      if (!cancelled) {
        setCapabilities(buildCapabilities(privateSignals));
      }
    };

    refresh();
    detectPrivateBrowsingSignals().then((signals) => {
      privateSignals = signals || {};
      refresh();
    });
    const timer = setTimeout(refresh, 600);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  return capabilities;
}
